/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconOmega = createReactComponent("outline", "omega", "IconOmega", [["path", { "d": "M4 19h5v-1a7.35 7.35 0 1 1 6 0v1h5", "key": "svg-0" }]]);

export { IconOmega as default };
//# sourceMappingURL=IconOmega.mjs.map
